import { createAction } from 'typesafe-actions';

import type { FieldSpec, OperationsSpec, TemplateDto } from '@/services/ws-bi/src/main/resources/rest-api';

export const setFieldSpecs = createAction('setFieldSpecs')<FieldSpec[]>();
export const setOperationSpecs = createAction('setOperationSpecs')<OperationsSpec>();
export const setTemplate = createAction('setTemplate')<TemplateDto | null>();
export const setTemplates = createAction('setTemplates')<TemplateDto[]>();
export const removeTemplate = createAction('removeTemplate')<string>();
export const setSendModalOpened = createAction('setSendModalOpened')<boolean>();
